/**
 * `rankingScale: null` = máximo desconocido (pregunta borrada del CMS después de responderla, TANAI-2575): se da
 * por correcta si sacó puntos, el mismo criterio con el que se guarda `isCorrect` en `job.data`.
 */
export const getResultStatus = (isEvaluable, rankingScale, score, answer) => {
  if (!isEvaluable) return answer ? 'done' : 'notDone';
  if (rankingScale === null) return score > 0 ? 'correct' : 'incorrect';
  return score === rankingScale ? 'correct' : 'incorrect';
};

export const getQuestionStatus = (data, ranking_scale, score, answer, viewed_solution_at) => {
  const status = getResultStatus(_getData(data)?.data?.isEvaluable, ranking_scale, score, answer);
  return ['quizz-results-bullets--' + status, 'quizz-results-bullets--viewed-status-' + (viewed_solution_at ? 'viewed' : 'not-viewed')];
};

function _getData(data) {
  let newData = data;
  try {
    newData = JSON.parse(data);
    if (!newData.data) {
      newData = {
        type: newData.type,
        metadata: newData.metadata,
        reference: newData.question_guid,
        data: newData,
      };
    }
  } catch {
    // Si falla el parse, mantener los datos originales
  }
  return newData;
}
